<template>
    <div class="question-list" id="questionList">
        <!-- {{solves}} -->
        <div class="tab_bar">
            <div class="mdc-tab-bar view-tab-bar" role="tablist"  ref="questionTab">
                <div class="mdc-tab-scroller">
                    <div class="mdc-tab-scroller__scroll-area mdc-tab-scroller__scroll-area--scroll mgb-000">
                        <div class="mdc-tab-scroller__scroll-content">
                            <div v-for="(solve, index) in solves" :key="index">
                                <button class="mdc-tab " role="tab" tabindex="0"
                                    :class="solve.questionId===currentQuestionId ? 'mdc-tab--active' : ''"
                                    @click="moveQuestion(solve)"
                                >
                                    <span class="mdc-tab__content">
                                        <span class="mdc-tab__text-label">
                                            <div class="t-headline10">
                                                <div :class="solve.correct ? 'question-correct' : 'question-incorrect'"></div>
                                                <div :class="!solve.isSolve ? 't-color-headlineBlack': 't-line-through-gray t-color-quizBlueGray'">{{index+1}}</div>
                                            </div>
                                        </span>
                                    </span>
                                    <span class="mdc-tab-indicator "
                                        :class="solve.questionId===currentQuestionId ? 'mdc-tab-indicator--active' : ''"
                                    >
                                        <span class="mdc-tab-indicator__content mdc-tab-indicator__content--underline"></span>
                                    </span>
                                    <span class="mdc-tab__ripple mdc-ripple-upgraded"></span>
                                </button>
                            </div>
                            
                            
                        </div>
                    </div>
                </div>
            </div>
        </div>
       <div class="divider mgt--1"></div>
    </div>
</template>

<script>
/**
 * 시험 피드백 문항 네비게이션 컴포넌트(exam feedback question navigation component)
 *
 * @author minkyoung.park@emcast.com
 */

// Components/Mixin/Extend/API define
import {MDCTabBar, MDCTabBarFoundation} from '@material/tab-bar'
export default {
    props: ['solves', 'currentQuestionId'],
    data() {
        return {
            questionTab: null,
            
        }
    },
    
    mounted() {
        this.questionTab = new MDCTabBar(this.$refs.questionTab)
    },

    methods: {
        // 문항 이동(move question)
        moveQuestion(solve) {
            this.$emit('selectQuestionNavi', solve)
        },

        isCurrentQuestion(questionId) {
            return questionId === this.currentQuestionId
        }
    }

}
</script>